export const hosts = {
  FAKE: 0,
  JIRA: 1,
  STANDALONE: 2
}
